var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrivateNotesWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 4L15 3L17 5.5L19 8.5L18 21H6V4Z",
    fill: "#A461D8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_234_1885)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4578 7.33333L15.0972 2.3299C15.0027 2.23368 14.8947 2.13746 14.7597 2.09622C14.6517 2.02749 14.5032 2 14.3682 2H6.51105C6.18704 2 5.86303 2.05498 5.55253 2.17869C5.24202 2.30241 4.97202 2.49485 4.74251 2.71478C4.51301 2.94845 4.32401 3.22337 4.189 3.52577C4.0675 3.84192 4 4.17182 4 4.50172V19.4983C4 19.8282 4.0675 20.1581 4.2025 20.4742C4.32401 20.7766 4.51301 21.0515 4.75601 21.2852C4.98552 21.5189 5.26902 21.7113 5.56603 21.8213C5.86303 21.9313 6.20054 22 6.52455 22H17.2167C17.5407 22 17.8648 21.945 18.1753 21.8213C18.4858 21.6976 18.7558 21.5052 18.9853 21.2852C19.2148 21.0515 19.4038 20.7766 19.5388 20.4742C19.6603 20.1581 19.7413 19.8282 19.7413 19.4983V8.00687C19.7143 7.7457 19.6333 7.51203 19.4578 7.33333ZM14.5167 8.00687C14.3142 7.99313 14.1252 7.88316 13.9902 7.73196C13.8687 7.56701 13.7877 7.37457 13.8147 7.16838V4.00687L17.5002 8.00687H14.5167Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5005 8.00684H14.5305C14.328 7.99309 14.139 7.88312 14.0039 7.73192C13.8824 7.56697 13.8014 7.37453 13.8284 7.16835V4.00684L17.5005 8.00684Z",
    fill: "#A461D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3429 13.8351C13.4635 13.5602 14.152 12.4193 13.8955 11.2784C13.6255 10.1375 12.5049 9.43645 11.3844 9.69762C10.2639 9.97253 9.57539 11.1134 9.8319 12.2543C10.0884 13.3952 11.2224 14.0962 12.3429 13.8351Z",
    fill: "#A461D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4761 14.165C14.3276 14.0687 14.1521 14.0275 13.9631 14.0138C13.7066 14.0138 13.4501 14.1237 13.2611 14.3024C12.8696 14.6598 12.5726 14.9072 11.8571 14.9072C11.1551 14.9072 10.8311 14.6461 10.4665 14.3024C10.291 14.1375 10.0885 14.0275 9.85903 14.0138C9.64303 14 9.42703 14.0412 9.25152 14.165C8.71151 14.5086 7.60449 15.5533 7.60449 18.4399C7.60449 18.5498 7.60449 18.6598 7.60449 18.7698C7.61799 19.0034 7.807 19.1959 8.0365 19.1959H9.77803H11.0201H12.6401H13.8416H15.6776C15.9071 19.1959 16.1096 19.0034 16.1096 18.7698C16.1096 18.6598 16.1096 18.5498 16.1096 18.4399C16.1231 15.5533 15.0161 14.5086 14.4761 14.165ZM14.8271 17.5739H13.9631V18.4536H12.8561V17.5739H11.9921V16.4467H12.8561V15.567H13.9631V16.4467H14.8271V17.5739Z",
    fill: "#A461D8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_234_1885"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.7143,
    height: 20,
    fill: "white",
    transform: "translate(4 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivateNotesWhite);
export default __webpack_public_path__ + "static/media/private-notes-white.38f4717bb5d8bb72596eccaf2bdeb7c9.svg";
export { ForwardRef as ReactComponent };